import { render, staticRenderFns } from "./Page-2.vue?vue&type=template&id=feeda2a4&scoped=true&"
var script = {}
import style0 from "./Page-2.vue?vue&type=style&index=0&id=feeda2a4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feeda2a4",
  null
  
)

export default component.exports